<script>
  import { Swiper } from 'cl-svelte-ui'
  import Tile from '@components/Tile'
  import Arrows from '@components/Arrows'
  import Modal from '@components/Modal'
  import Gallery from '@components/Gallery'
  import { store, bindAction } from '@store'
  import { onMount, onDestroy } from 'svelte'
  import { swiperArticleConfig } from '@config'
  import { showModalAction, showModalSelector } from '@ducks/layout'

  export let data, items, isEnd, isBeginning, SwiperElem, gallery
  let swiperWrapper, activeGalerryItem, showModal = false, swiperContainer


  const showModalBindAction = () => showModal = true//bindAction(showModalAction)
  const showModalHandle = activeItem => {
    showModalBindAction(true)
    activeGalerryItem = activeItem
  }
  const closeModal = () => showModal = false//showModalBindAction(false)

  const checkSlidePosition = () => {
    isEnd = SwiperElem && SwiperElem.api && SwiperElem.api.isEnd
    isBeginning = SwiperElem && SwiperElem.api && SwiperElem.api.isBeginning
    console.log(isEnd)
  }

  const setArrowContainer = () => {
    const container = document.getElementById('content-container')
    const containerLeft = container && container.getBoundingClientRect().left
    if (swiperWrapper) {
      swiperWrapper.style.left = containerLeft + 15 + 'px' // 15 - paddings
    }
  }
  // выставляем arrows по ширине первого слайда
  const setArrowsLeftPosition = () => {
    const arrowsElem = document.querySelector('.arrows');
    const swiperSlideElem = document.querySelector('.swiper-slide')
    const left = swiperSlideElem && swiperSlideElem.getBoundingClientRect().width
    if (arrowsElem) {
      arrowsElem.style.left = (left - arrowsElem.getBoundingClientRect().width) + 'px'
    }
    SwiperElem && SwiperElem.api && SwiperElem.api.update()
  }

  // этот костыль нужен для дебага позиции arrows, когда на клиенте переходим на странрицу новости
  const loadSlideImage = index => {
    if (index === 0) {
      //setArrowsLeftPosition()
      SwiperElem && SwiperElem.api && SwiperElem.api.update()
      checkSlidePosition()
    }
  }

  // const setHeight = () => {
  //   const titles = document.querySelectorAll('.title')
  // }

  const prevArrowHandle = () => SwiperElem && SwiperElem.api && SwiperElem.api.slidePrev()
  const nextArrowHandle = () => SwiperElem && SwiperElem.api && SwiperElem.api.slideNext()


  onMount(() => setTimeout(() => {
    SwiperElem && SwiperElem.api && SwiperElem.api.on('transitionEnd', () => {
      checkSlidePosition()
    })

    SwiperElem && SwiperElem.api && SwiperElem.api.on('resize', () => {
      setArrowContainer()
      SwiperElem && SwiperElem.api && SwiperElem.api.update()
      //setArrowsLeftPosition()
      checkSlidePosition()
    })

    setArrowContainer()
    //setArrowsLeftPosition()
    SwiperElem && SwiperElem.api && SwiperElem.api.update()
    checkSlidePosition()
    //setHeight()
  }))

  onDestroy(() => {
    if(!store.isServer) {
      SwiperElem && SwiperElem.api && SwiperElem.api.destroy()
    }
  })

  $: items = (data && data.items) || []
  //$: showModal = showModalSelector($store)
</script>
  <div class="swiper-custom-container" bind:this={swiperContainer}>
    <div class="swiper-custom-container__wrapper" bind:this={swiperWrapper}>
      <Swiper options={swiperArticleConfig || {}} bind:this={SwiperElem}>
        {#each items as {src, description}, index}
          <div class="swiper-slide" on:click={() => src && showModalHandle(index)} class:cursor-pointer={src}>
            <div class="d-flex align-items-start flex-column">
              <img src='https://njerusalem.ru{src}' class="swiper-slide-img" class:broken={!src} on:load={() => loadSlideImage(index)}/>
              <!--<div class="title">{ description || '' }</div>-->
            </div>
          </div>
        {/each}
      </Swiper>
      <div class="mt-2">
        <Arrows
          {prevArrowHandle}
          {isEnd}
          {isBeginning}
          {nextArrowHandle}
        />
      </div>
    </div>
  </div>
  {#if showModal}
    <Modal closeHandle={closeModal}>
      <Gallery
        bind:this={gallery}
        activeItem={activeGalerryItem}
        closeHandle={closeModal}
      >
        {#each items as {src, description}, index}
          <div class="swiper-slide d-flex justify-content-center align-items-center position-relative gallery-slide">
            <div class="position-relative text-center">
              <img
                src='https://njerusalem.ru{src}'
                class="swiper-slide-img gallery-img"
                class:broken={!src} on:load={() => loadSlideImage(index)}
              />
              {#if description}
                <div class="description text-white p-2 p-md-4">{description}</div>
              {/if}
            </div>
          </div>
        {/each}
      </Gallery>
    </Modal>
  {/if}

<style>
  .swiper-custom-container {
    height: calc(250px + 0.5 * 16px + 45px);
    @media (max-width: 767px) {
      height: calc(211px + 0.5 * 16px + 45px);
    }
    width: 100%;
    margin-bottom: 1.5rem;
    :global(.arrows) {
      position: absolute;
      left: 0;
    }
    .swiper-custom-container__wrapper {
      position: absolute;
      right: 0;
      /*max-width: calc(1140px + ((100% - 1140px - 40px) / 2));*/
      /*@media (max-width: 1350px) {*/
        /*max-width: calc(100% - 100px - 25px);*/
      /*}*/
      /*@media (max-width: 767px) {*/
        /*max-width: calc(100% - 50px);*/
      /*}*/
    }
    .swiper-slide.cursor-pointer {
      cursor: pointer;
    }
    .swiper-slide {
      max-width: 450px;
      overflow: hidden;
      width: auto;
      position: relative;
      &:last-child {
         margin-right: 0!important;
       }
      .title {
        poosition: relative;
        font-family: Myriad Pro;
        margin-top: 15px;
        line-height: 1.375rem;
        float: left;
        font-size: 0.875rem;
        letter-spacing: 0.05em;
        max-height: calc(8 * 1.375rem);
        @media(max-width: 767px) {
          max-height: calc(10 * 1.375rem);
        }
        max-width: calc(166px * 2);
        overflow: hidden;
        :after {
          content: '...';
          position: absolute;
          right: 0;
          top: 100%;
        }
      }
      .swiper-slide-img.broken {
        width: 450px!important;
      }
      .swiper-slide-img {
        position: relative;
        width: auto;
        height: 250px;
      @media (max-width: 767px) {
        height: 211px;
      }
      &:after {
         content: 'Не удалось загрузить изобржение ;(';
         position: absolute;
         left: 0;
         top: 0;
         background: grey;
         color: white;
         display: flex;
         justify-content: center;
         align-items: center;
         z-index: -1;
         width: 100%;
         height: 100%;
       }
      }
    }
  }
  .gallery-img {
    max-width: 100%;
    @media (max-width: 767px) {
      max-height: 70vh;
    };
    max-height: 85vh;

  }
  .description {
    @media (max-width: 767px) {
      /*position: absolute;*/
      /*width: 100%;*/
      /*bottom: 0;*/
      font-size: 0.8rem;
      /*background: rgba(0, 0, 0, 0.6);*/
    };
  }

</style>
